import useFetch, { CachePolicies } from 'use-http';
import type { TTechDetailsResponse } from '../technical-details/technical-details.types';
import { API_ROUTES } from '../../constants';
import { TAPIFetchTechDetails } from './reset-secret-application.types';

export const useAPIResetSecretApplication = (): TAPIFetchTechDetails => {
  const { data, put, error, loading, response } = useFetch<TTechDetailsResponse>(API_ROUTES.APPLICATIONS, {
      cachePolicy: CachePolicies.NO_CACHE
  });

  async function resetSecret(id: string): Promise<TTechDetailsResponse['data']>{
    const data = await put(`/${id}/reset-client-secret`);
    return data?.data;
  };

  return {
    data: data?.data || data,
    loading,
    error,
    loaded: response.ok,
    resetSecret
  };
};
